import {
  BeelineLogo,
  Logo1C,
  LoyaltyIntegrationLogo,
  MangoLogo,
  MaxMessengerLogo,
  YooKassaLogo,
} from '@app/assets';
import {
  ACQUIRING,
  ATC_BEELINE,
  ATC_MANGO,
  EMAIL_HANDLER,
  INSTAGRAM,
  LOYALTY_PROGRAM_SENDOUTS,
  MAX_MESSENGER,
  NEW_LEAD_INTEGRATION,
  SMS_SERVICE,
  TECH_SUPPORT,
  TELEGRAM,
  TELEGRAM_PERSONAL,
  VK,
  WAREHOUSE_1C,
  WHATSAPP,
  YOOKASSA,
} from '@app/constants';
import {
  EMAIL_COLOR,
  INSTAGRAM_COLOR,
  NEW_LEAD_INTEGRATION_COLOR,
  SMS_SERVICE_COLOR,
  TECH_SUPPORT_COLOR,
  TELEGRAM_COLOR,
  VK_COLOR,
  WHATS_APP_COLOR,
} from '@app/constants/integrationsColors';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface FontAwesomeIconConfig {
  kind: 'fa';
  icon: IconProp;
  color: string;
  fixedWidth?: boolean;
}

interface ImageIconConfig {
  kind: 'img';
  src: string;
  alt: string;
}

export type IntegrationIconConfig = FontAwesomeIconConfig | ImageIconConfig;

export const INTEGRATION_ICONS_MAP: Record<string, IntegrationIconConfig> = {
  [WHATSAPP]: {
    kind: 'fa',
    icon: 'fa-brands fa-square-whatsapp' as IconProp,
    color: WHATS_APP_COLOR,
  },
  [INSTAGRAM]: {
    kind: 'fa',
    icon: 'fa-brands fa-square-instagram' as IconProp,
    color: INSTAGRAM_COLOR,
  },
  [VK]: {
    kind: 'fa',
    icon: 'fa-brands fa-vk' as IconProp,
    color: VK_COLOR,
  },
  [TELEGRAM]: {
    kind: 'fa',
    icon: 'fa-solid fa-robot' as IconProp,
    color: TELEGRAM_COLOR,
  },
  [TELEGRAM_PERSONAL]: {
    kind: 'fa',
    icon: 'fa-brands fa-telegram' as IconProp,
    color: TELEGRAM_COLOR,
  },
  [EMAIL_HANDLER]: {
    kind: 'fa',
    icon: 'fa-solid fa-envelope' as IconProp,
    color: EMAIL_COLOR,
  },
  [ATC_BEELINE]: {
    kind: 'img',
    src: BeelineLogo,
    alt: 'Beeline',
  },
  [ATC_MANGO]: {
    kind: 'img',
    src: MangoLogo,
    alt: 'Mango',
  },
  [MAX_MESSENGER]: {
    kind: 'img',
    src: MaxMessengerLogo,
    alt: 'Max Messenger',
  },
  [YOOKASSA]: {
    kind: 'img',
    src: YooKassaLogo,
    alt: 'YooKassa',
  },
  [ACQUIRING]: {
    kind: 'img',
    src: YooKassaLogo,
    alt: 'YooKassa',
  },
  [WAREHOUSE_1C]: {
    kind: 'img',
    src: Logo1C,
    alt: '1C',
  },
  [LOYALTY_PROGRAM_SENDOUTS]: {
    kind: 'img',
    src: LoyaltyIntegrationLogo,
    alt: 'Loyalty Program',
  },
  [NEW_LEAD_INTEGRATION]: {
    kind: 'fa',
    icon: 'fa-solid fa-user-plus' as IconProp,
    color: NEW_LEAD_INTEGRATION_COLOR,
    fixedWidth: true,
  },
  [SMS_SERVICE]: {
    kind: 'fa',
    icon: 'fa-solid fa-comment-sms' as IconProp,
    color: SMS_SERVICE_COLOR,
  },
  [TECH_SUPPORT]: {
    kind: 'fa',
    icon: 'fa-solid fa-headset' as IconProp,
    color: TECH_SUPPORT_COLOR,
    fixedWidth: true,
  },
};
